/** Picks v2 or v1 of the My Account page based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import AccountPage   from './AccountPage';
import AccountPageV2 from './v2/AccountPageV2';

export default function AccountPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? AccountPageV2 : AccountPage;
  return <Component {...props} />;
}
